import { Div } from '@jaymathew/ui-shared/elements/Div'
import { Footer } from '@jaymathew/ui-shared/elements/Footer'
import { MobileAppBar } from '@jaymathew/ui-shared/elements/MobileAppBar'
import { Button, useMediaQuery } from '@mui/material'
import { SxProps, Theme, useTheme } from '@mui/material/styles'
import {
	useState
} from 'react'
import { Outlet } from 'react-router-dom'
import {
	adminSettingsURL,
	autoNotificationsURL,
	bonusLevelURL,
	communitiesURL,
	footerHeight,
	logo,
	manageUsersPage,
	notificationCampaignsURL,
	notificationURL,
	notificationsURL,
	pointsReportsURL,
	regionsURL,
	rewardsURL,
	unclaimedPointsURL
} from 'resources/constants'
import { InAppBannerOutlet } from 'shared/elements/InAppBannerOutlet'
import { Sidebar } from 'shared/modules/sidebar'

const styles = {
	background: {
		backgroundColor: (theme) => theme.palette.background.default,
		margin: 'auto',
		backgroundSize: 'cover',
		zIndex: -1,
		height: '100%',
		minHeight: '100vh',
		width: '100%',
		overflow: 'auto',
		paddingBottom: `${footerHeight}px`,
	} as SxProps<Theme>,

	childrenWithDrawerOpen: {
		marginLeft: { xs: 0, md: 30 },
		marginTop: { xs: 5, md: 0 },
		transition: (theme) => theme.transitions.create(['margin'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
		p: 2,
	} as SxProps<Theme>,

	childrenWithDrawerClosed: {
		marginLeft: { xs: 0, md: 7.5 },
		marginTop: { xs: 5, md: 0 },
		transition: (theme) => theme.transitions.create('margin', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
		p: { xs: 0, md: 2 },
		pt: { xs: 2, md: 2 }, // this doesn't work as just a 2
	} as SxProps<Theme>,
}

const LayoutWithSidebar = () => {

	const { breakpoints } = useTheme()
	const isMobile = useMediaQuery(breakpoints.down('md'))

	const [drawerOpen, setDrawerOpen] = useState(!isMobile)
	const toggleDrawer = () => {
		setDrawerOpen((prevState) => !prevState)
	}

	return (
		<>
			<Div sx={styles.background}>
				<MobileAppBar logo={logo} toggleDrawer={toggleDrawer} />

				<Sidebar
					toggleDrawer={toggleDrawer}
					drawerOpen={drawerOpen}
				/>

				{drawerOpen ? (
					<Div sx={styles.childrenWithDrawerOpen}>
						<InAppBannerOutlet
							extraBlockedPaths={[
								notificationCampaignsURL,
								notificationURL,
								notificationsURL,
								autoNotificationsURL,
								manageUsersPage,
								regionsURL,
								communitiesURL,
								unclaimedPointsURL,
								rewardsURL,
								bonusLevelURL,
								autoNotificationsURL,
								pointsReportsURL,
								adminSettingsURL,
							]}
							// optional: override the default action button
							renderAction={(n) => <Button size='small' href={n.action?.url ?? `/notifications/${n.id}`}>Open</Button>}
						/>
						<Outlet />
					</Div>
				) : (
					<Div sx={styles.childrenWithDrawerClosed}>
						<InAppBannerOutlet
							// optional: override the default action button
							renderAction={(n) => <Button size='small' href={n.action?.url ?? `/notifications/${n.id}`}>Open</Button>}
						/>
						<Outlet />
					</Div>
				)}
			</Div>
			<Footer footerHeight={footerHeight} />
		</>
	)
}

export default LayoutWithSidebar
